import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import {OrderSummary, OrderTree } from 'src/app/services/api/orders/orders.service';


@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})

export class OrderDetailComponent implements OnInit {

  @Input() tree: OrderTree;
  @Input() params: any;
  @Input() summary: OrderSummary;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();
  @Output() decompositeOrderEvent = new EventEmitter();

  constructor() {
  }


  ngOnInit() {
  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }

  decompositeOrder() {
    this.decompositeOrderEvent.emit();
  }

}
